/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Listview = (props: any) => (
<svg {...props}   viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
<g id="24px/listview">
<line id="Line 88" x1="13.75" y1="5.25" x2="21.25" y2="5.25" stroke="#282828" strokeWidth="inherit" strokeLinecap="round"/>
<line id="Line 90" x1="13.75" y1="12.25" x2="21.25" y2="12.25" stroke="#282828" strokeWidth="inherit" strokeLinecap="round"/>
<line id="Line 92" x1="13.75" y1="19.25" x2="21.25" y2="19.25" stroke="#282828" strokeWidth="inherit" strokeLinecap="round"/>
<line id="Line 89" x1="2.75" y1="5.25" x2="10.25" y2="5.25" stroke="#282828" strokeWidth="inherit" strokeLinecap="round"/>
<line id="Line 91" x1="2.75" y1="12.25" x2="10.25" y2="12.25" stroke="#282828" strokeWidth="inherit" strokeLinecap="round"/>
<line id="Line 93" x1="2.75" y1="19.25" x2="10.25" y2="19.25" stroke="#282828" strokeWidth="inherit" strokeLinecap="round"/>
</g>
</svg>
);

export default Listview;